import React from "react";
import { observer } from "mobx-react";
import { Fade } from "@material-ui/core";

import { useStore } from "../../store";
import { TranslationJSX } from "../../utils/Translation";
import { setWebBridge } from "../../utils/webBridge";
import { DownloadButton } from "./style";
import { IProject } from "../../store/feedStoreTypes";
import { languageAr } from "../../utils/Translation";
import firebaseEvent from "../../utils/firebaseEvent";
interface Props {
  project: IProject;
}

const DetailItemDownload = ({
  project: {
    assetLevel,
    projectLevel,
    projectId: id,
    filePath: file_url,
    translation: { title },
  },
}: Props) => {
  const {
    appStore: { appState },
    detailStore: {
      infoState: { isMoreInfo },
      onUpdateStart,
      onDownloadStart,
      completedProjects,
    },
  } = useStore();

  const { className } = languageAr(appState.languageCode);

  const isUpdateCheck = () => {
    console.log(appState.assetLevel, appState.projectLevel);
    console.log(assetLevel, projectLevel);
    if (!appState.assetLevel || !appState.projectLevel) return false;
    return (
      assetLevel > appState.assetLevel || projectLevel > appState.projectLevel
    );
  };

  const onClickDownload = (e: any) => {
    e.stopPropagation();
    //Firebase Event
    const jsonParams = {
      P1: id,
    };
    firebaseEvent("detail_download", jsonParams);
    if (isUpdateCheck()) return onUpdateStart("download");

    const args = JSON.stringify({
      id,
      title,
      file_url,
      type: 0,
    });
    setWebBridge({
      name: "onDownloadStart",
      args,
    });
    onDownloadStart();
  };

  const disabledDownloadButton = completedProjects.includes(id);
  const locoKey = disabledDownloadButton
    ? "feed_downloaded_button"
    : "feed_download_button";

  return (
    <Fade in={!isMoreInfo}>
      <DownloadButton
        className={className}
        color="primary"
        variant="contained"
        onClick={onClickDownload}
        disabled={disabledDownloadButton}
      >
        <TranslationJSX locoKey={locoKey} />
      </DownloadButton>
    </Fade>
  );
};

export default observer(DetailItemDownload);
